import type { BackofficeClient } from "@/api/backoffice-v2/backoffice-client";
import type { SiteId } from "@/types/common/ids";
import type { QueryClient } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";

import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toRef } from "vue";

import { TransferSignatureQueryKeys } from "@/api/backoffice-v2/voltacall/transfer-signature-query-keys.ts";
import { useBackofficeClient } from "@/hooks/backoffice/use-backoffice-client";

type SubscriberDetailsClient = Pick<BackofficeClient["transferSignature"], "getSubscriberDetails">;

export function voltacallSubscriberDetailsQueryOptions(
  client: SubscriberDetailsClient,
  maybeSiteIdRef: MaybeRefOrGetter<SiteId>,
) {
  const siteId = toRef(maybeSiteIdRef);

  return queryOptions({
    queryKey: TransferSignatureQueryKeys.subscriberDetails(siteId.value),
    queryFn: () => client.getSubscriberDetails(siteId.value),
  });
}

export async function refreshVoltacallSubscriberDetailsQuery(
  queryClient: QueryClient,
  client: SubscriberDetailsClient,
  siteId: SiteId,
) {
  const options = voltacallSubscriberDetailsQueryOptions(client, siteId);

  await queryClient.invalidateQueries({ queryKey: options.queryKey, refetchType: "all" });
  return queryClient.fetchQuery(options);
}

export function useSubscriberDetailsQuery(maybeSiteIdRef: MaybeRefOrGetter<SiteId>) {
  const client = useBackofficeClient();

  return useQuery(voltacallSubscriberDetailsQueryOptions(client.transferSignature, maybeSiteIdRef));
}
